import { createAction } from 'redux-act';

// get Department action
const getFilteredDropdownDataRequest = createAction('GET_FILTERED_DROPDOWN_DATA_REQUEST', data => data);
const getFilteredDropdownDataSuccess = createAction('GET_FILTERED_DROPDOWN_DATA_SUCCESS', data => data);
const getFilteredDropdownDataError = createAction('GET_FILTERED_DROPDOWN_DATA_ERROR');

//add Dropdown Data
const addDropdownDataRequest = createAction('ADD_DROPDOWN_DATA_REQUEST', data => data);
const addDropdownDataSuccess = createAction('ADD_DROPDOWN_DATA_SUCCESS', data => data);
const addDropdownDataError = createAction('ADD_DROPDOWN_DATA_ERROR');

// get Dropdown action
const getAllDropdownDataRequest = createAction('GET_ALL_DROPDOWN_DATA_REQUEST', data => data);
const getAllDropdownDataSuccess = createAction('GET_ALL_DROPDOWN_DATA_SUCCESS', data => data);
const getAllDropdownDataError = createAction('GET_ALL_DROPDOWN_DATA_ERROR');

// DELETE Dropdown action
const deleteDropdownDataRequest = createAction('DELETE_DROPDOWN_DATA_REQUEST', data => data);
const deleteDropdownDataSuccess = createAction('DELETE_DROPDOWN_DATA_SUCCESS', data => data);
const deleteDropdownDataError = createAction('DELETE_DROPDOWN_DATA_ERROR');

// UPDATE Dropdown action
const updateDropdownDataRequest = createAction('UPDATE_DROPDOWN_DATA_REQUEST', data => data);
const updateDropdownDataSuccess = createAction('UPDATE_DROPDOWN_DATA_SUCCESS', data => data);
const updateDropdownDataError = createAction('UPDATE_DROPDOWN_DATA_ERROR');

// Get Dropdown Master ConstantData
const getDropdownMasterConstantDataRequest = createAction('GET_DROPDOWN_MASTER_CONSTANT_DATA_REQUEST', data => data);
const getDropdownMasterConstantDataSuccess = createAction('GET_DROPDOWN_MASTER_CONSTANT_DATA_SUCCESS', data => data);
const getDropdownMasterConstantDataError = createAction('GET_DROPDOWN_MASTER_CONSTANT_DATA_ERROR');

// Get Dropdown Category Data
const addMasterDropdownCategoryRequest = createAction('ADD_MASTER_DROPDOWN_CATEGORY_REQUEST', data => data);
const addMasterDropdownCategorySuccess = createAction('ADD_MASTER_DROPDOWN_CATEGORY_SUCCESS', data => data);
const addMasterDropdownCategoryError = createAction('ADD_MASTER_DROPDOWN_CATEGORY_ERROR');

// Get Master Dropdown Category Data
const getMasterDropdownCategoryRequest = createAction('GET_MASTER_DROPDOWN_CATEGORY_REQUEST', data => data);
const getMasterDropdownCategorySuccess = createAction('GET_MASTER_DROPDOWN_CATEGORY_SUCCESS', data => data);
const getMasterDropdownCategoryError = createAction('GET_MASTER_DROPDOWN_CATEGORY_ERROR');

// Get All Master Dropdown Category Data
const getAllMasterDropdownCategoryRequest = createAction('GET_ALL_MASTER_DROPDOWN_CATEGORY_REQUEST', data => data);
const getAllMasterDropdownCategorySuccess = createAction('GET_ALL_MASTER_DROPDOWN_CATEGORY_SUCCESS', data => data);
const getAllMasterDropdownCategoryError = createAction('GET_ALL_MASTER_DROPDOWN_CATEGORY_ERROR');

// Update Master Dropdown Category Data
const updateMasterDropdownCategoryRequest = createAction('UPDATE_MASTER_DROPDOWN_CATEGORY_REQUEST', data => data);
const updateMasterDropdownCategorySuccess = createAction('UPDATE_MASTER_DROPDOWN_CATEGORY_SUCCESS', data => data);
const updateMasterDropdownCategoryError = createAction('UPDATE_MASTER_DROPDOWN_CATEGORY_ERROR');

// Delete Master Dropdown Category Data
const deleteMasterDropdownCategoryRequest = createAction('DELETE_MASTER_DROPDOWN_CATEGORY_REQUEST', data => data);
const deleteMasterDropdownCategorySuccess = createAction('DELETE_MASTER_DROPDOWN_CATEGORY_SUCCESS', data => data);
const deleteMasterDropdownCategoryError = createAction('DELETE_MASTER_DROPDOWN_CATEGORY_ERROR');


// add Question action
const createQuestionRequest = createAction('CREATE_QUESTION_REQUEST', data => data);
const createQuestionSuccess = createAction('CREATE_QUESTION_SUCCESS', data => data);
const createQuestionError = createAction('CREATE_QUESTION_ERROR');

// get Question action
const getQuestionRequest = createAction('GET_QUESTION_REQUEST', data => data);
const getQuestionSuccess = createAction('GET_QUESTION_SUCCESS', data => data);
const getQuestionError = createAction('GET_QUESTION_ERROR');

// get Question bY Department action
const getAllQuestionRequest = createAction('GET_ALL_QUESTION_REQUEST', data => data);
const getAllQuestionSuccess = createAction('GET_ALL_QUESTION_SUCCESS', data => data);
const getAllQuestionError = createAction('GET_ALL_QUESTION_ERROR');

// Update Question action
const updateQuestionRequest = createAction('Update_QUESTION_REQUEST', data => data);
const updateQuestionSuccess = createAction('Update_QUESTION_SUCCESS', data => data);
const updateQuestionError = createAction('Update_QUESTION_ERROR');

// Delete Question action
const deleteQuestionRequest = createAction('Delete_QUESTION_REQUEST', data => data);
const deleteQuestionSuccess = createAction('Delete_QUESTION_SUCCESS', data => data);
const deleteQuestionError = createAction('Delete_QUESTION_ERROR');

// Delete Question action
const addAnswerRequest = createAction('ADD_ANSWER_REQUEST', data => data);
const addAnswerSuccess = createAction('ADD_ANSWER_SUCCESS', data => data);
const addAnswerError = createAction('ADD_ANSWER_ERROR');

// Delete Question action
const getDropDownMasterRequest = createAction('GET_DROPDOWN_MASTER_REQUEST', data => data);
const getDropDownMasterSuccess = createAction('GET_DROPDOWN_MASTER_SUCCESS', data => data);
const getDropDownMasterError = createAction('GET_DROPDOWN_MASTER_ERROR');



// clear existing Dropdown action
const handleClearDropdownStore = createAction('HANDLE_CLEAR_DDROPDOWN_STORE', data => data);

export default {
    getFilteredDropdownDataRequest,
    getFilteredDropdownDataSuccess,
    getFilteredDropdownDataError,

    addDropdownDataRequest,
    addDropdownDataSuccess,
    addDropdownDataError,

    getAllDropdownDataRequest,
    getAllDropdownDataSuccess,
    getAllDropdownDataError,

    deleteDropdownDataRequest,
    deleteDropdownDataSuccess,
    deleteDropdownDataError,

    updateDropdownDataRequest,
    updateDropdownDataSuccess,
    updateDropdownDataError,

    getDropdownMasterConstantDataRequest,
    getDropdownMasterConstantDataSuccess,
    getDropdownMasterConstantDataError,

    addMasterDropdownCategoryRequest,
    addMasterDropdownCategorySuccess,
    addMasterDropdownCategoryError,

    updateMasterDropdownCategoryRequest,
    updateMasterDropdownCategorySuccess,
    updateMasterDropdownCategoryError,

    getMasterDropdownCategoryRequest,
    getMasterDropdownCategorySuccess,
    getMasterDropdownCategoryError,

    getAllMasterDropdownCategoryRequest,
    getAllMasterDropdownCategorySuccess,
    getAllMasterDropdownCategoryError,

    deleteMasterDropdownCategoryRequest,
    deleteMasterDropdownCategorySuccess,
    deleteMasterDropdownCategoryError,

    createQuestionRequest,
    createQuestionSuccess,
    createQuestionError,

    getQuestionRequest,
    getQuestionSuccess,
    getQuestionError,

    getAllQuestionRequest,
    getAllQuestionSuccess,
    getAllQuestionError,

    updateQuestionRequest,
    updateQuestionSuccess,
    updateQuestionError,

    deleteQuestionRequest,
    deleteQuestionSuccess,
    deleteQuestionError,

    addAnswerRequest,
    addAnswerSuccess,
    addAnswerError,

    getDropDownMasterRequest,
    getDropDownMasterSuccess,
    getDropDownMasterError,

    handleClearDropdownStore

}